import { Component, Watch, Vue } from "vue-property-decorator";
import user_module from '@/modules/user';
import Loader from '@/components/loader/Loader.vue';
import ModalAccept from '@/components/modal-accept/index.vue';


type Site = {
  id: string, 
  link: string,
  name?: string
  unique?: string
}

@Component({
  components: {
    Loader,
    ModalAccept
  }
})

export default class Iframe extends Vue {



  currentProduct: string = 'lexe';
  displayPS: boolean = true;
  tryLoginPS: boolean = false;
  addedProducts: string[] = [];

  iframeWidth: string = '100%';
  iframeHeight: string = '100%';

  printWidth: string = '1000px';
  printHeight: string = '2000px';

  loading: boolean = false;
  loadedLexe: boolean = false;

  @Watch('$route')
  changeRoute(next: any, prev: any){

    if (next.name !== prev.name && next.name !== 'thankyou'){

      console.log('changeRoute', next, prev);

      this.changeProduct(next.name, next.fullPath);

      this.toggleTawk(next.name);

      if (!this.loadedLexe && next.name === 'lexe'){

        this.loading = true;

      } else {

        this.loading = false;
      }

    }

  }
  

  @Watch('currentRouteFullPath')
  postMessage(){

    const iframe: any = this.$refs['iframe_' + this.id];

    const reg = new RegExp("/" + this.site + "/");

    const href: string = this.$route.fullPath
    .replace(reg, "")
    
    console.log('this.iframPath', this.iframePath, this.currentRouteFullPath, this.id);

    if (this.id !== 'pow' && (decodeURIComponent(this.iframePath) !== decodeURIComponent(this.currentRouteFullPath) && (this.iframePath !== this.currentRouteFullPath) && iframe && iframe[0])){

      console.log('post?', href);
      
      iframe[0].contentWindow.postMessage({appstore: true, href}, '*');

      const link: string = '/' + this.site + '/' + href

      const newSite = {
        link: link,
        id: this.id
      }
      
      user_module.changeSiteField(newSite);

      console.log('appstore href', href);

      sessionStorage.setItem('page_' + this.site, href);

    }
    
  }

  get iframeDimension(){

    return `width: ${this.iframeWidth}; height: ${this.iframeHeight}`
  }


  get isMobile(){

    return user_module.isMobile;
  }

  get firstIframe(){

    return user_module.firstIframe;
  }

  get base(){

    return user_module.base;
  }

  get url(){

    return  this.base + '/' + this.site + this.currentRoute;
  }

  get password(){

    return user_module.password;
  }

  get newToken(){
    
    return user_module.newToken;
  }


  get fingerPrint(){

    return user_module.fingerPrint;
  }

  get login(){
    return user_module.login;
  }


  get iframePath(): string{

    const sites = this.currentSites;
    const site = sites.find((s: Site) => s.id === this.id);

    return site?.link || '';

  }
  get currentRoute(){

    console.log('currentRoute!!!');

    if(this.single){

      return '';

    } else {
      
      let href = '/' + (sessionStorage.getItem('page_' + this.site) || (this.mvp ? '' : "index"));
      console.log('href', href);
      return href;

    }
  }

  get id(){

    return this.$route.name || '';
  }

  get productData(): any{

    return this.currentSites.find(product => product?.id === this.id) || {};
  }

  get site(){

    return this.productData.site ||  '';

  }

  
  get single(){

    return this.productData.single || false;
  }

  get mvp(){

    return this.productData.mvp || false;
  }

  get recipient(): string{

    return this.base + this.site;
  }

  get currentRouteFullPath() {

    return this.$route.fullPath;

  }

  get rawPassword(){

    return user_module.rawPassword;
  }

  get currentSites(){

    return user_module.currentSites;
  }


  getSrc(id: string, link: string){

    console.log('getSrc');

    if (id === 'ps'){
      
      let PSLink = `https://larkspurweb.com/planisphere`;

      // if (this.tryLoginPS){

        PSLink += `/Search.aspx?ProductSelector=PSP&login=${this.login}&Agree=on&password=${encodeURIComponent(this.rawPassword)}&appstore=true`;

      // } else {

      //   PSLink += '/Search.aspx?appstore=true';

      // }

      return PSLink
      
    }

    let src = this.base + link;

    if (!/(&|\?)appstore=true/.test(link)){

      src += (link.indexOf('?') > -1 ? '&' : '?') + 'appstore=true';
    }

    if (id === 'crm'){

      src = src.replace(/&token=.+&login=.+/, '');
     

    }

    return src;

  }

  get loadedProducts(){
    
    return this.currentSites
    .filter(product => {

      return this.addedProducts.find(addedProduct => addedProduct === product.id) && (product.id !== 'ps' || this.displayPS);

    })
    .map(product => ({
      ...product, 
      display: product.id === this.currentProduct,
      defaultLink: this.getSrc(product.id, product.defaultLink)
    }))
  }

  changeProduct(name: string, defaultLink?: string){

    if (name === 'lexe'){

      this.loading = true;

    } else {

      this.loading = false;
    }



    this.currentProduct = name;

    console.log('this.route', this.$route, name);

    const favicon = document.getElementById('favicon');

    if (this.$route.meta?.iframe){

      favicon?.setAttribute('href', '/favicon-' + name + '.ico');

      document.documentElement.style.overflow = 'hidden';

      document.getElementsByTagName('body')[0].style.height = '100%';

      if (this.addedProducts.indexOf(name) === -1 && !this.$route.meta.exception){
        
        if (defaultLink){

          const newSite = {
            defaultLink,
            id: this.id
          }
  
          user_module.changeSiteField(newSite);
          
        }


        this.addedProducts.push(name);
  
      }

    } else {
      
      favicon?.setAttribute('href', '/favicon.ico');
      
      document.documentElement.style.overflowY = 'scroll';
      
      const body: any = document.getElementsByTagName('body')[0];
      
      body.style.height = null;
    
    }

    this.toggleTawk(name);

  }

  receiveMessage(message: any){
    
    if (message.data && message.data.loadTemplates){

      this.loadedLexe = true;
      this.loading = false;
    }


    if (!this.single && this.id === message.data?.product){

      if (message.data?.href){
      
        let path = message.data.href;
  
        if (this.mvp){
  
          path = '/' + this.site + path;
  
        }
  
        this.$router.replace(path).catch(()=>{});
  
        this.$route.params.id = path;
    
        const newSite = {
          link: '/' + this.site + '/' + path,
          id: this.id
        }
  
        user_module.changeSiteField(newSite);
  
        sessionStorage.setItem('page_' + this.site, path);
  
        this.postMessage();
  
      }

      const printDimensions = message.data?.printDimensions

      if (printDimensions){
        
        this.printWidth = '1055px';
        this.printHeight = printDimensions.height + 1000 + 'px';
        
      }
      
    }

    // if (message.data.product === 'ps'){

    //   if (!message.data.login && !this.tryLoginPS){
    //     this.displayPS = false;
    //     this.tryLoginPS = true;

    //     this.$nextTick(() => {
    //       this.displayPS = true;
    //     })

    //   }
    // }


  }

  beforePrint(){

    const iframe: any = this.$refs['iframe_' + this.id];

    if (iframe && iframe[0]){
      
      iframe[0].contentWindow.postMessage({appstore: true, scroll: true}, '*');

    }

    this.iframeWidth = this.printWidth
    this.iframeHeight = this.printHeight;
  }

  afterPrint(){
    this.iframeWidth = '100%';
    this.iframeHeight = '100%';
  }

  toggleTawk(name){


    const tawk = document.getElementsByClassName('widget-visible')[0] || document.getElementsByClassName('widget-hidden')[0]; 

    console.log('tawk!!!', tawk);

    if (tawk){
      
      if (name === 'pctnew' || name === 'remai'){

        tawk.classList.add('widget-hidden');
        tawk.classList.remove('widget-visible')
        
      } else {
  
        tawk.classList.remove('widget-hidden');
        tawk.classList.add('widget-visible')
  
      }

    }


  }

  beforeMount() {
    this.changeProduct(this.$route.name, this.$route.fullPath); 
    


  }

  mounted(){

    this.$route.params.id = sessionStorage.getItem('page_' + this.site) || (this.mvp ? '' : "index");

    window.addEventListener('message', this.receiveMessage);
    window.addEventListener("beforeprint", this.beforePrint);
    window.addEventListener("afterprint", this.afterPrint);

    setTimeout(() => {
      this.toggleTawk(this.$route.name);
    }, 7000)
    
  }

  beforeDestroy(){
    
    window.removeEventListener('message', this.receiveMessage);
    
  }

}